import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import NewsPost from "@/pages/NewsPost";
import Register from "@/pages/Register";
import EventMrsSouthIndia from "@/pages/EventMrsSouthIndia";
import WinnerSpotlight from "@/pages/WinnerSpotlight";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import SiteContent from "@/pages/admin/SiteContent";
import GalleryManager from "@/pages/admin/GalleryManager";
import ServicesManager from "@/pages/admin/ServicesManager";
import TestimonialsManager from "@/pages/admin/TestimonialsManager";
import BlogManager from "@/pages/admin/BlogManager";
import Messages from "@/pages/admin/Messages";
import AdminRegistrations from "@/pages/admin/AdminRegistrations";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
      <AuthProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/events/mrs-south-india-2026" element={<EventMrsSouthIndia />} />
            <Route path="/news/:id" element={<NewsPost />} />
            <Route path="/winners/taufiq-mansoor-ansari" element={<WinnerSpotlight />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="content" element={<SiteContent />} />
              <Route path="gallery" element={<GalleryManager />} />
              <Route path="services" element={<ServicesManager />} />
              <Route path="testimonials" element={<TestimonialsManager />} />
              <Route path="blog" element={<BlogManager />} />
              <Route path="messages" element={<Messages />} />
              <Route path="registrations" element={<AdminRegistrations />} />
            </Route>
            </Routes>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </ReactLenis>
  );
}

export default App;
